import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function Leaderboard2k26Promo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <InformationWrapper>
                <Container>
                    <TopBanner>
                        <SectionTitle>
                            2026 Leaderboard &#45; Climb & Win Big
                        </SectionTitle>

                        <div className='staticImg2'>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.leaderboardMarPrizes}`}
                                alt="Cricket One"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </div>
                    </TopBanner>

                    <TermsSection>
                        <TermsTitle>Terms &amp; Conditions</TermsTitle>
                        <TermsList>
                            <li>✪ Top 10 weekly and Top 3 monthly players win</li>
                            <li>✪ Weekly & monthly prize pools apply</li>
                            <li>✪ To be eligible for weekly or monthly leaderboard prizes, players must <br />achieve a minimum qualifying turnover amount of ₹100,000 during the <br /> promotion period</li>
                            <li>✪ Weekly winnings credited every Monday at 12 PM</li>
                            <li>✪ Monthly winnings credited on 7th of the following month</li>
                            <li>✪ Calculation period: Sunday to Saturday</li>
                            <li>✪ Valid until 31 May 2026</li>
                            <li>✪ General leaderboard rules apply</li>
                        </TermsList>
                    </TermsSection>
                </Container>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(Leaderboard2k26Promo));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 2rem 0 1rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #EBEBEB;
    overflow: hidden;
    color: #444;
    text-transform: capitalize;

    .staticImg2 {
        width: 100%;
        max-width: 910px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
        }
    }
`;

const TopBanner = styled.div`
    width: 100%;
    padding: 2.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: #fff;
    border-radius: 14px;

`;

const Container = styled.div`
    width: 100%;
    max-width: 1100px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 18px;
  margin: 0 0 30px;
  color: ${theme('palette.Leaderboard2k26PromoSectionTitleColor')};
  text-transform: capitalize;
  font-weight: 700;
`;

const TermsSection = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    border: ${theme('palette.Leaderboard2k26PromoTermsSectionBrdr')};
    background: ${theme('palette.Leaderboard2k26PromoTermsSectionBcColor')};
    padding: 1rem 5rem;
    margin-top: 2rem;
    text-align: center;
`;

const TermsTitle = styled.h3`
  font-size: 22px;
  color: ${theme('palette.Leaderboard2k26PromoSectionTitleColor')};
  margin-bottom: 20px;
`;

const TermsList = styled.ol`
  margin: 0 auto;
  padding-left: 22px;
  text-align: left;
  font-size: 14px;
  line-height: 1.8;
  color: #444;
  list-style: none;

  strong {
    font-family: 'Inter-Bold';
  }
`;